export var OptionValue;
(function (OptionValue) {
    OptionValue["Photo"] = "PROPERTY_IMAGE";
    OptionValue["EnergyCertificate"] = "ENERGY_CERTIFICATE";
    OptionValue["Logo"] = "LOGO";
    OptionValue["Map"] = "MAP";
    OptionValue["Document"] = "DOCUMENT";
    OptionValue["Other"] = "OTHER";
})(OptionValue || (OptionValue = {}));
export var OptionLabel;
(function (OptionLabel) {
    OptionLabel["Photo"] = "gallery.floorplans.feedback_survey.radio_item.photo";
    OptionLabel["EnergyCertificate"] = "gallery.floorplans.feedback_survey.radio_item.energy_certificate";
    OptionLabel["Logo"] = "gallery.floorplans.feedback_survey.radio_item.logo";
    OptionLabel["Map"] = "gallery.floorplans.feedback_survey.radio_item.map";
    OptionLabel["Document"] = "gallery.floorplans.feedback_survey.radio_item.document";
    OptionLabel["Other"] = "gallery.floorplans.feedback_survey.radio_item.other";
})(OptionLabel || (OptionLabel = {}));
